// Assets
import { getAltresDades } from 'api/services/wp';
import { useEffect, useRef, useState } from 'react';

// Scss
import './BannerHomeLaCatDelSi.scss';
import useIsPhone from 'modules/website/hooks/useIsPhone';
import useIsTablet from 'modules/website/hooks/useIsTablet';

function BannerHomeLaCatDelSi() {
  const [banner, setBanner] = useState({});
  const container = useRef(null);
  const isPhone = useIsPhone();
  const isTablet = useIsTablet();

  useEffect(() => {
    if (container.current) {
      getAltresDades().then(({ data }) => {
        setBanner({
          pc: data[0].acf.banner.banner_home_pc,
          tablet: data[0].acf.banner.banner_home_tablet,
          phone: data[0].acf.banner.banner_home_phone,
        });
      });
    }
  }, [container]);

  function getBannerUrl() {
    if (isPhone) {
      return banner.phone;
    }

    if (isTablet) {
      return banner.tablet;
    }

    return banner.pc;
  }

  return (
    <div className="bannerhomelacatldelsi__container" ref={container}>
      <a href={getBannerUrl()?.enllac || undefined} target="_blank" rel="noreferrer">
        {!!getBannerUrl() && <img src={getBannerUrl().imatge} alt="" />}
      </a>
    </div>
  );
}

export default BannerHomeLaCatDelSi;
